(() => {
  document.documentElement.classList.remove('no-js');

  const moneyText = (value) => value || '';
  const shopRoot = window.Shopify?.routes?.root || '/';
  const syncMenuLock = () => {
    document.body.style.overflow = document.querySelector('[data-mobile-menu][open]') ? 'hidden' : '';
  };

  document.querySelectorAll('[data-mobile-menu]').forEach((menu) => {
    const close = menu.querySelector('[data-mobile-close]');
    menu.addEventListener('toggle', syncMenuLock);
    if (close) close.addEventListener('click', () => {
      menu.removeAttribute('open');
      syncMenuLock();
    });
    menu.querySelectorAll('nav a').forEach((link) => {
      link.addEventListener('click', () => {
        menu.removeAttribute('open');
        syncMenuLock();
      });
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-menu][open]').forEach((menu) => menu.removeAttribute('open'));
    syncMenuLock();
  });

  document.querySelectorAll('[data-hotspot]').forEach((hotspot) => {
    hotspot.addEventListener('click', () => hotspot.classList.toggle('is-open'));
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const galleryItems = [...root.querySelectorAll('[data-media-id]')];
    const thumbnails = [...root.querySelectorAll('[data-media-target]')];
    const variantField = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');
    const form = root.querySelector('.ep-product-form');
    const status = root.querySelector('[data-product-status]');
    const availabilityText = root.querySelector('[data-availability-text]');
    const availabilityDot = root.querySelector('[data-availability-dot]');
    let currentAvailable = true;

    const showMedia = (mediaId) => {
      if (!mediaId) return;
      galleryItems.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === String(mediaId)));
      thumbnails.forEach((thumb) => {
        const isActive = thumb.dataset.mediaTarget === String(mediaId);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });
    };

    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget));
    });

    const updateVariant = () => {
      if (!variantField || variantField.tagName !== 'SELECT') return;
      const option = variantField.options[variantField.selectedIndex];
      if (!option) return;

      if (price) price.textContent = moneyText(option.dataset.price);
      if (stickyPrice) stickyPrice.textContent = moneyText(option.dataset.price);
      if (compare) {
        compare.textContent = moneyText(option.dataset.compare);
        compare.hidden = !option.dataset.compare;
      }

      currentAvailable = option.dataset.available === 'true';
      if (addButton) addButton.disabled = !currentAvailable;
      if (addLabel) addLabel.textContent = currentAvailable ? 'Ajouter au panier' : 'Épuisé';
      if (availabilityText) availabilityText.textContent = currentAvailable ? root.dataset.availabilityCopy : 'Épuisé';
      if (availabilityDot) availabilityDot.classList.toggle('is-unavailable', !currentAvailable);
      showMedia(option.dataset.mediaId);
    };

    if (variantField && variantField.tagName === 'SELECT') {
      variantField.addEventListener('change', updateVariant);
      updateVariant();
    }

    root.querySelectorAll('[data-scroll-product]').forEach((button) => {
      button.addEventListener('click', () => {
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (variantField && variantField.tagName === 'SELECT') {
          window.setTimeout(() => variantField.focus({ preventScroll: true }), 450);
        }
      });
    });

    if (form && window.fetch) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!addButton || addButton.disabled) return;

        const previousLabel = addLabel ? addLabel.textContent : '';
        addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Ajout en cours…';
        if (status) status.textContent = '';

        try {
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || "Impossible d'ajouter ce produit.");

          if (status) status.textContent = 'Le produit a bien été ajouté au panier.';
          if (addLabel) addLabel.textContent = 'Ajouté ✓';

          const cartResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.ep-cart-link__count').forEach((count) => {
              count.textContent = cart.item_count;
            });
          }
        } catch (error) {
          if (status) status.textContent = error.message;
          if (addLabel) addLabel.textContent = previousLabel;
        } finally {
          window.setTimeout(() => {
            addButton.disabled = !currentAvailable;
            if (addLabel && addLabel.textContent === 'Ajouté ✓') {
              addLabel.textContent = currentAvailable ? previousLabel : 'Épuisé';
            }
          }, 1400);
        }
      });
    }
  });
})();
